export interface PerformanceEvaluationExtendedDto {
  EmployeeFirstName: string;
  EmployeeLastName: string;
  EmployeeVpId: string;
  EmployeeCompanyId: string | null;
  EmployeeVpCompanyId: number | null;
  VpJobId: string;
  JobCompanyId: string | null;
  JobVpCompanyId: number | null;
  EmployeeHrRef: number | null;
  EmployeeJobStartDate: Date | null;
  EmployeeJobEndDate: Date | null;
  ROFNote: string;
  ManPowerReqDetailId: string | null;
  LastModifiedUserName: string;
}
